import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

import {
  FaDownload,
  FaMapMarkerAlt,
  FaBriefcase,
  FaEnvelope,
  FaPhoneAlt,
  FaGithub,
  FaLinkedin,
  FaUser,
} from 'react-icons/fa';

import Picture from '../assets/pictures/moi-black-white.webp';

import '../utils/general.css';
import '../utils/profil.css';

import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';
import { useLanguage } from '../components/languageContext';
import Seo from '../components/seo';

export default function Profil() {
  const { language } = useLanguage();

  const translations = language === 'en' ? enTranslations : frTranslations;
  const { profil } = translations;

  const [showEmail, setShowEmail] = useState(false);
  const [showPhone, setShowPhone] = useState(false);

  const githubUrl = 'https://github.com/PierreSaumet';
  const linkedinUrl = 'https://www.linkedin.com/in/pierre-saumet/';
  const cvUrl = `${process.env.PUBLIC_URL}/CV_PIERRE_SAUMET_WEBSITE.pdf`;

  const playZogzog = () => {
    new Audio(`${process.env.PUBLIC_URL}/zogzog.mp3`).play().catch(() => {});
  };

  return (
    <Container className="ps-profil-page vertical-center mb-5 pt-5" fluid>
      <Seo title={translations.seo.profil.title} description={translations.seo.profil.description} />
      <Row className="ps-row justify-content-center pt-0 mt-5">
        <Col xl={9} lg={10}>
          <div className="ps-profil-card">
            <Row className="align-items-center">
              <Col lg={4} className="ps-profil-picture-wrapper text-center mb-4 mb-lg-0">
                <Image
                  src={Picture}
                  roundedCircle
                  alt="Pierre Saumet"
                  className="ps-profil-picture"
                  onClick={playZogzog}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') playZogzog();
                  }}
                />
              </Col>

              <Col lg={8} className="text-center text-lg-start">
                <h1 className="ps-profil-name">
                  {profil.firstname} {profil.lastname}
                </h1>
                <p className="ps-profil-job">
                  <FaBriefcase className="me-2" aria-hidden="true" />
                  {profil.job}
                </p>
                <p className="mb-4" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  {profil.baseline}
                </p>

                <a
                  href={cvUrl}
                  download
                  className="ps-profil-cv-btn"
                >
                  <FaDownload aria-hidden="true" />
                  {profil.download_cv}
                </a>
                <span className="ps-profil-cv-updated">{profil.cv_updated}</span>
              </Col>
            </Row>

            <Row className="mt-5">
              <Col lg={6}>
                <h2 className="ps-profil-section-title mb-2">{profil.contact_title}</h2>
                <ul className="ps-profil-infos">
                  <li>
                    <span className="ps-profil-icon">
                      <FaUser aria-hidden="true" />
                    </span>
                    <span>
                      {profil.firstname} {profil.lastname}
                    </span>
                  </li>
                  <li>
                    <span className="ps-profil-icon">
                      <FaMapMarkerAlt aria-hidden="true" />
                    </span>
                    <span>{profil.location}</span>
                  </li>
                  <li>
                    <span className="ps-profil-icon">
                      <FaEnvelope aria-hidden="true" />
                    </span>
                    {showEmail ? (
                      <p> {profil.email}</p>
                    ) : (
                      <button
                        type="button"
                        className="ps-profil-reveal-btn"
                        onClick={() => setShowEmail(true)}
                      >
                        <span className="ps-profil-blurred">{profil.email}</span>
                        <span className="ps-profil-reveal-hint">{profil.reveal_hint}</span>
                      </button>
                    )}
                  </li>
                  <li>
                    <span className="ps-profil-icon">
                      <FaPhoneAlt aria-hidden="true" />
                    </span>
                    {showPhone ? (
                      <p>{profil.phone}</p>
                    ) : (
                      <button
                        type="button"
                        className="ps-profil-reveal-btn"
                        onClick={() => setShowPhone(true)}
                      >
                        <span className="ps-profil-blurred">{profil.phone}</span>
                        <span className="ps-profil-reveal-hint">{profil.reveal_hint}</span>
                      </button>
                    )}
                  </li>
                </ul>
              </Col>

              <Col lg={6} className="mt-5 mt-lg-0">
                <h2 className="ps-profil-section-title mb-2">{profil.socials_title}</h2>
                <div className="ps-profil-socials">
                  <a
                    href={githubUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ps-profil-social-btn"
                  >
                    <FaGithub aria-hidden="true" />
                    GitHub
                  </a>
                  <a
                    href={linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ps-profil-social-btn"
                  >
                    <FaLinkedin aria-hidden="true" />
                    LinkedIn
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
